function setCookie(name,value,days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (date.toUTCString() || "")  + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function eraseCookie(name) {   
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

let LEGAL_EXPIRES = getCookie('LEGAL_EXPIRES');
let LEGAL_ACCEPT = document.getElementById('legal_accept');
var body = document.body;

LEGAL_ACCEPT.onclick = function(e){
  e.preventDefault();
  if(LEGAL_EXPIRES == false || LEGAL_EXPIRES == null ) {
    setCookie('LEGAL_EXPIRES', true, 2);
    document.getElementById('shopify-section-section-legal').style.display = 'none';
    body.classList.remove("overflow-hidden");
  }
}

if(LEGAL_EXPIRES != false && LEGAL_EXPIRES != null ) {
  document.getElementById('shopify-section-section-legal').style.display = 'none';
  jQuery('html, body').removeClass('overflow-hidden');
  body.classList.remove("overflow-hidden");
} else {
  body.classList.add("overflow-hidden");
}
